/**
 * Global options.
 */
export var options = {
    verbose: true,
    commercialLicense: false,
    classNamePrefix: "amcharts-",
    autoSetClassName: false,
    minPolylineStep: 0.5,
    onlyShowOnViewport: false,
    queue: false,
    licenses: []
};
//# sourceMappingURL=Options.js.map